export { default } from "./ProofOfCoverage";

export const BASE_COVERAGE_PATH = "coverage";
export const COVERAGE_ROUTES = {
  ADD_EVENT: "add-event",
  EVENT: "event",
};

export const ADD_EVENT_ROUTES = {
  EVENT_TYPE: "event-type",
  EVENT_DETAILS: "event-details",
  EVENT_DOCUMENTS: "event-documents",
  EVENT_SUMMARY: "event-summary",
  EVENT_ADDED: "event-added",
};

export const BASE_PROOF_OF_COVERAGE_PATH = "proof-of-coverage";

export const PROOF_OF_COVERAGE_ROUTES = {
  POLICY_TYPE: "policy-type",
  POLICY_DOCUMENT: "policy-document",
  COVERAGE_ADDED: "coverage-added",
  ACTIVE_TLL_FOUND: "active-tll-found",
  SCHEDULED_TLL_FOUND: "scheduled-tll-found",
  COVERAGE_DOCUMENTS: "coverage-documents",
};
